import { combineReducers } from 'redux';
import games from './gameReducer';
import players from './playerReducer';
import rounds from './roundReducer';
import stacks from './stackReducer';

export default combineReducers({
  games,
  players,
  rounds,
  stacks
});
